import PayerGroup from '@/services/payer_group'

const fetchPayerGroups = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    PayerGroup.fetch().then((response) => {
      commit('SET_LIST', response.data.data)
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

const findPayerGroups = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    PayerGroup.get(id).then((response) => {
      commit('SET_PAYER_GROUP', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const savePayerGroups = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    const { verb, payer_group } = payload
    const method = verb === 'put' ? 'update' : 'save'

    PayerGroup[method](payer_group)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        commit('SET_ERRORS', error.response.data)
        reject(error)
      })
  })
}

const updatePayerGroupsValues = ({ commit }, payload) => {
  commit('UPDATE_VALUES', payload)
}

const resetPayerGroupsStateErrors = ({ commit }) => {
  commit('RESET_ERRORS')
}

export default {
  fetchPayerGroups,
  findPayerGroups,
  savePayerGroups,
  updatePayerGroupsValues,
  resetPayerGroupsStateErrors
}



// WEBPACK FOOTER //
// ./src/features/clients/store/payer_groups/actions.js